import React from "react";
import img1 from "../../assets/ingridients-images/pachancare/jeera.webp";
import img2 from "../../assets/ingridients-images/pachancare/pippali.webp";
import img3 from "../../assets/ingridients-images/pachancare/pudina.webp";
import img4 from "../../assets/ingridients-images/pachancare/saunf.webp";
import img5 from "../../assets/ingridients-images/pachancare/triphala.webp";
import img6 from "../../assets/ingridients-images/pachancare/vidang.webp";

const data = [
  {
    title: "Jeera",
    img: img1,
    text: "Promotes cartilage health and flexibility",
  },
  {
    title: "Pippali",
    img: img2,
    text: "Soothes discomfort & aids recovery",
  },
  {
    title: "Pudina",
    img: img3,
    text: "Supports joint comfort and inflammation balance",
  },
   {
    title: "Saunf",
    img: img4,
    text: "Imporves flexibility & joint health",
  },
   {
    title: "Triphala",
    img: img5,
    text: "Enhances nutrient absorption",
  },
   {
    title: "Vidang",
    img: img6,
    text: "Promotes comfort",
  },

];

const PachancareIngredients = () => {
  return (
    <section className="ingredients">
      <h2 className="ingredients-title">
        Key Ingredients for Joint Support
      </h2>

      <div className="ingredients-grid">
        {data.map((item, index) => (
          <div className="ingredient-card" key={index}>
            <div className="pill">{item.title}</div>

            <div className="image-circle">
              <img src={item.img} alt={item.title} />
            </div>

            <p>{item.text}</p>
            <div className="card-shadow"></div>
          </div>
        ))}
      </div>
    </section>
    
  );
};

export default PachancareIngredients;
